import state from './state'
import mutations from './mutations'

const services = {
  state,
  mutations
}

export default services



// WEBPACK FOOTER //
// ./src/store/services/index.js